import * as searchAtoms from 'src/atoms/search'
import * as mapAtoms from 'src/atoms/main-map'
import { atom, selector } from 'recoil'
import { keyFactory, uncachedSelector } from 'src/utils/recoil'
import { bounds } from 'src/atoms/main-map'
import { ZONING_PARENT_MCODES_MAP } from 'src/constants/cherre-data-dictionary/zoning-colors'
import { Feature, Geometry } from 'src/common-services'
import { alphamapClient } from 'src/clients'
import { geoToH3, kRingDistances } from 'h3-js'

const key = keyFactory('parcel-boundaries')

const rings = atom({
  key: 'h3-rings',
  default: 2,
})

export const resolution8Hexes = uncachedSelector({
  key: key('map-r8-hexes'),
  get: ({ get }) => {
    const b = get(bounds)
    const ringCount = get(rings)
    const center = geoToH3(b.center[1], b.center[0], 8)
    const ring = ringCount > 0 ? kRingDistances(center, ringCount).flat() : []
    return [center].concat(ring)
  },
})

export const resolution5Hexes = uncachedSelector({
  key: key('map-r5-hexes'),
  get: ({ get }) => {
    const b = get(bounds)
    const ringCount = get(rings)
    const center = geoToH3(b.center[1], b.center[0], 5)
    const ring = ringCount > 0 ? kRingDistances(center, ringCount).flat() : []
    return [center].concat(ring)
  },
})

export const roundedZoom = uncachedSelector({
  key: key('roundedZoom'),
  get: ({ get }) => {
    const zoom = get(mapAtoms.zoom)
    return Math.round(zoom)
  },
})

export const activeMCodes = atom<string[]>({
  key: key('active-mcodes'),
  default: ZONING_PARENT_MCODES_MAP.flatMap((m) => m.mCodes),
})

export const selectedLocationParcel = selector<Feature<Geometry, { mCode: string }> | undefined>({
  key: key('selected-location-parcel'),
  get: async ({ get }) => {
    const location = get(searchAtoms.selectedLocation)
    if (!location) {
      return undefined
    }
    const [lng, lat] = location.latLng.coordinates
    return await alphamapClient.locations.getLocationParcel(lat, lng)
  },
})
